import { render, staticRenderFns } from "./PageSeoConfigs.vue?vue&type=template&id=0aa7c996&"
import script from "./PageSeoConfigs.vue?vue&type=script&lang=js&"
export * from "./PageSeoConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa7c996')) {
      api.createRecord('0aa7c996', component.options)
    } else {
      api.reload('0aa7c996', component.options)
    }
    module.hot.accept("./PageSeoConfigs.vue?vue&type=template&id=0aa7c996&", function () {
      api.rerender('0aa7c996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/seo-configs/PageSeoConfigs.vue"
export default component.exports